module.exports = __webpack_public_path__ + "img/188.0033939c.jpg";